import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';

import { FeaturedColumns } from '../../components/price-row-columns/featured-columns';
import { UnfeaturedColumns } from '../../components/price-row-columns/unfeatured-columns';
import { OptionsColumn } from './options-cloumn';

import type { ProductOffer } from 'src/types';
import type { ITableLinkProps } from '../../types';
import { ViewSize } from '../../types';

import { StyledCard, Row } from '../styles';

type Props = {
  alternativeOffer: ProductOffer;
  priceRowRef?: React.RefObject<HTMLDivElement>;
  tableLinkProps: ITableLinkProps;
};

export const AlternativePriceRow = ({
  alternativeOffer,
  priceRowRef,
  tableLinkProps,
}: Props) => {
  const { isFeatured, viewSize } = usePriceRowContext();
  const { externalUri } = alternativeOffer;

  return (
    <StyledCard $expanded $featured={isFeatured} $isAlternative>
      <Row
        $expanded
        $featured={isFeatured}
        $isAlternative
        $noExternalUri={!externalUri}
      >
        {viewSize === ViewSize.SMALL && (
          <OptionsColumn alternativeOffer={alternativeOffer} />
        )}

        {viewSize >= ViewSize.MEDIUM && (
          <OptionsColumn alternativeOffer={alternativeOffer} />
        )}

        {isFeatured && alternativeOffer.externalUri && (
          <FeaturedColumns
            alternativeOffer={alternativeOffer}
            tableLinkProps={tableLinkProps}
          />
        )}
        {(!isFeatured || !alternativeOffer.externalUri) && (
          <UnfeaturedColumns
            alternativeOffer={alternativeOffer}
            isAlternative
            priceRowRef={priceRowRef}
            tableLinkProps={tableLinkProps}
          />
        )}
      </Row>
    </StyledCard>
  );
};
